import {useEffect} from 'react';

import {workingHoursApi} from 'api';
import {Card, DataWrapper, PredefinedNotifierType} from 'components';
import {useApiData} from 'hooks';

import {BaseWorkingHours} from '../BaseWorkingHours';

export const PersonalWorkingHours: React.FC = () => {
    const {send: getWorkingHours, data: workingHours, loading: getLoading} = useApiData(workingHoursApi.getForPersonal, {
        notificationType: PredefinedNotifierType.FetchError
    });

    const {send: updateWorkingHours, loading: updateLoading} = useApiData(workingHoursApi.updateForPersonal, {
        onSuccess: getWorkingHours,
        notificationType: PredefinedNotifierType.Save
    });

    useEffect(() => {
        getWorkingHours();
    }, [getWorkingHours]);

    return (
        <div className='tw-relative'>
            <Card className='tw-mt-4'>
                <DataWrapper isLoading={getLoading || updateLoading}>
                    <BaseWorkingHours
                        workingHours={workingHours}
                        loading={getLoading || updateLoading}
                        onSubmit={updateWorkingHours}
                    />
                </DataWrapper>
            </Card>
        </div>
    );
};